import React, { useState } from 'react'

export const ThemeContext = React.createContext({Theme:false as any, setTheme: null as any})

interface ThemeProviderProps {
    children: JSX.Element
}

export const ThemeProvider = ({children}: ThemeProviderProps) => {

    type ThemeProps = {
        isDark: string
    }

    const [Theme, setTheme] = useState<ThemeProps>({isDark: JSON.parse(localStorage.getItem('isDark')!) !== null ? JSON.parse(localStorage.getItem('isDark')!) : "true"})

    return (
        <ThemeContext.Provider value={{Theme, setTheme}}>
            {children}
        </ThemeContext.Provider>
    )
}
